import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-50 transition-all duration-300 ${
      scrolled ? "bg-slate-900/95 backdrop-blur-lg shadow-lg shadow-black/20" : "bg-slate-900/80 backdrop-blur-md"
    } border-b border-slate-700/50`}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <Link
            to="/"
            className="flex items-center gap-2 hover:scale-105 transition-transform duration-300 group"
          >
            <div className="relative">
              <img
                src="/LLogo.png"
                alt="استودیو آلتو"
                className="h-8 w-auto transition-all duration-300 group-hover:brightness-110"
              />
              <div className="absolute inset-0 bg-teal-500/20 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10" />
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-5 text-sm">
            <Link to="/" className="text-slate-300 hover:text-teal-400 transition-colors">
              خانه
            </Link>
            <a href="/#portfolio" className="text-slate-300 hover:text-teal-400 transition-colors">
              نمونه‌کارها
            </a>
            <Link
              to="/coresell"
              className="text-teal-300 hover:text-teal-200 font-semibold px-2.5 py-1 rounded-lg bg-teal-500/10 border border-teal-500/30 flex items-center gap-1.5 transition-all shadow-sm"
            >
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-teal-500"></span>
              </span>
              محصول کورسل
            </Link>
            <Link to="/shop" className="text-slate-300 hover:text-teal-400 transition-colors">
              فروشگاه قالب
            </Link>
          </nav>
        </div>

        <div className="flex items-center gap-3">
          <Link
            to="/coresell"
            className="md:hidden text-xs text-teal-300 font-medium px-2 py-1 rounded bg-teal-500/10 border border-teal-500/30"
          >
            کورسل
          </Link>
          <a
            href="https://wa.me/09134378347"
            target="_blank"
            rel="noopener noreferrer"
            className="relative text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 px-4 py-2 rounded-lg shadow-sm hover:shadow-lg hover:shadow-teal-500/30 transition-all duration-200 overflow-hidden group"
          >
            <span className="relative z-10">تماس</span>
            <div className="absolute inset-0 bg-gradient-to-r from-teal-400 to-teal-600 translate-x-[-100%] group-hover:translate-x-0 transition-transform duration-300" />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
